import React, {PureComponent} from 'react'
import cn from 'classnames'
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import withHover from '../../hoc/withHover'
import flow from 'lodash/flow'
import Heading from "../Widgets/Heading"
import SocialLinks from "./SocialLinks"
import CategoryLabelAndTime from "../Widgets/CategoryLabelAndTime"
import CentredContentContainer from "../Widgets/CentredContentContainer"
import RichTextContainer from "../Widgets/RichTextContainer"
import Subtitle from "../Widgets/Subtitle"
import Section from '../Widgets/Section'

class HorizontalHero extends PureComponent {
    
    render() {
        const {classes, article, images, isMobile} = this.props;
        const {link, linkedin_share} = article;
        const video = article.video_mobile && isMobile ? article.video_mobile : article.video;

        const ArticleMeta = () => (
            <CentredContentContainer className={cn(classes.authorMeta, article.hero_image_above_title && classes.bottomMarginless)} alignContent='center'>
                <CategoryLabelAndTime article={article} />
                <Heading classes={classes}>{article.title}</Heading>
                {article.sub_title && <Subtitle className="normalVerticalFlow" classes={classes}>{article.sub_title}</Subtitle>}
                <SocialLinks size="large" showLinkedIn={linkedin_share} />
            </CentredContentContainer>
        );

        return (
            <div>
                <Section className={classes.container}>
                    {!article.hero_image_above_title && <ArticleMeta />}
                    <div className="row">
                        <ImageOrVideo
                            key={video ? video.id : "image"}
                            images={images}
                            video={video}
                            link={link}
                            className={classes.image}
                            controls={true}
                        />
                    </div>
                    {article.hero_image_above_title && <ArticleMeta />}
                </Section>
                {article.details && (
                    <section>
                        <CentredContentContainer className={classes.content}><RichTextContainer content={article.details} removeBottomMargin={true}></RichTextContainer></CentredContentContainer>
                    </section>
                )}
            </div>
        );    
    }
}

export default flow([
    withHover,
    injectSheet(theme => ({
        container: {
            paddingTop: '0'
        },
        header: {
            textTransform: 'initial',
            maxWidth: 848
        },
        subTitle: {
            margin: '8px 0 16px 0',
            maxWidth: 449,
            ...theme.font.subtitle
        },
        image: {
            margin: '0'
        },
        authorMeta: {
            margin: '40px 0',
            [theme.breakpoint("tablet")]: {
                margin: '54px 0'
            }
        },
        bottomMarginless: {
            marginBottom: 0
        }
    }))
])(HorizontalHero)


// WEBPACK FOOTER //
// ./src/components/Article/HorizontalHero.js